import { render, staticRenderFns } from "./vuecommh120.vue?vue&type=template&id=535ba06f"
import script from "./vuecommh120.vue?vue&type=script&lang=js"
export * from "./vuecommh120.vue?vue&type=script&lang=js"
import style0 from "./vuecommh120.vue?vue&type=style&index=0&id=535ba06f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports